
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { memo, useState, useRef, useEffect } from 'react';
import Tooltip from '../../../Tooltip/Tooltip.js';
import { createElement as jsx } from '../../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { c as components } from '../../../../../node_modules/react-select/dist/index-a301f526.esm.js';

var CustomMultiValueLabel = function CustomMultiValueLabel(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowActive = _useState2[0],
    setIsOverflowActive = _useState2[1];
  var labelRef = useRef(null);
  var data = props.data,
    selectProps = props.selectProps;
  var label = data.label;
  var isDisabled = selectProps.isDisabled;
  var isTooltipDisabled = isDisabled || !isOverflowActive;
  useEffect(function () {
    if (labelRef.current) {
      var hasOverflow = labelRef.current.scrollWidth > labelRef.current.clientWidth;
      setIsOverflowActive(hasOverflow);
    }
  }, [label]);
  return jsx(components.MultiValueLabel, props, jsx(Tooltip, {
    content: label,
    disabled: isTooltipDisabled,
    parentProps: {
      "aria-label": label
    }
  }, jsx("div", {
    className: "custom-multi-value",
    ref: labelRef
  }, label)));
};
var CustomMultiValueLabel$1 = /*#__PURE__*/memo(CustomMultiValueLabel);

export { CustomMultiValueLabel$1 as default };
//# sourceMappingURL=CustomMultiValueLabel.js.map
